import Api from "../config/api";

export const saveProcedimento = async(procedimento) => {
  const method = procedimento.id ? 'updateProcedimento' : 'createProcedimento';
    const response = await Api.post("", {
      query: `
        mutation ($procedimento: ProcedimentoInput) {
          ${method}(procedimento: $procedimento) {
            id
            nome
            unidade {
              id
            }
            convenioProcedimentos {
              convenio {
                id
              }
              procedimento {
                id
              }
              valor
            }
            especialidades {
              id
              especialidade
            }
          }
        }`,
    variables: { procedimento }
  });

  if (response?.data?.errors) throw new Error(response.data.errors[0].message)
  return response.data.data[method]
  
};

export const findByIdProcedimento = id => Api.post("", {
  query: `
    query ($id: UUID) {
      findByIdProcedimento(id: $id) {
        nome
        ativo
        tiposProcedimentos
        duracaoProcedimento
        valorCusto
        orientacoes
        especialidades {
          id
          especialidade
        }
        tuss22ProcedimentoEventoSaude {
          id
          codigoTermo
          descricao
          codigoTermoDescricao
          localOdontograma {
            id
          }
        }
        convenioProcedimentos {
          convenio {
            id
          }
          procedimento {
            id
          }
          valorVigente {
          dataInicioVigencia
          dataFimVigencia
          valor
          id
          }
          valor
        }
        produtoProcedimentos {
          produto {
            id
          }
          quantidade
        }
    convenioProcedimentos {
      valores {
        valor
        id
        dataInicioVigencia
        dataFimVigencia
      }
      convenio {
        descricao
      }
      id
      procedimento {
        id
        nome
      }
      valor
      valorVigente {
        dataFimVigencia
        dataInicioVigencia
        id
        valor
      }
    }
      }
    }`,
  variables: { id }
});

export const findAllProcedimentos = (variables) => Api.post("", {
      query: `
      query ($nome: String, $ativo: Boolean, $pageableDTO: PageableDTOInput, $salaId: UUID, $convenioId: Long) {
        findAllProcedimentos(nome: $nome, ativo: $ativo, pageableDTO: $pageableDTO, salaId: $salaId, convenioId: $convenioId) {
          last
          totalElements
          content {
            id
            nome
            ativo
            unidade {
              id
            }
            tuss22ProcedimentoEventoSaude {
              codigoTermo
              descricao
              codigoTermoDescricao
            }
            convenioProcedimentos {
              procedimento {
                id
                nome
              }
              convenio {
                id
                descricao
              }
               valorVigente {
                id
                dataInicioVigencia
                dataFimVigencia
                valor
              }
              valor
            }
            produtoProcedimentos {
              procedimento {
                id
                nome
              }
              produto {
                id
                nome
              }
              quantidade
            }
          }
        }
      }
      
  `,
  variables: variables

});

export const findAllProcedimentosTable = async(variables) => {
  const response = await Api.post("", {
    query: `
      query ($nome: String, $ativo: Boolean, $pageableDTO: PageableDTOInput, $salaId: UUID, $convenioId: Long) {
        findAllProcedimentos(nome: $nome, ativo: $ativo, pageableDTO: $pageableDTO, salaId: $salaId, convenioId: $convenioId) {
          last
          content {
            id
            nome
            ativo
            tuss22ProcedimentoEventoSaude {
              codigoTermoDescricao
            }
            especialidades {
              id
              especialidade
            }
          }
        }
      }`,
      variables: variables
    });

  if (response?.data?.errors) throw new Error(response.data.errors[0].message)
  return response.data.data.findAllProcedimentos

}

export const findProcedimentos = (variables) => Api.post("", {
  query: `
      query ($nome: String, $ativo: Boolean, $pageableDTO: PageableDTOInput, $salaId: UUID, $convenioId: Long) {
        findAllProcedimentos(nome: $nome, ativo: $ativo, pageableDTO: $pageableDTO, salaId: $salaId, convenioId: $convenioId) {
          last
          content {
            id
            nome
          }
        }
      }
      
  `,
  variables: variables

});

export const findProcedimentosWithModalidade = (variables) => Api.post("", {
    query: `
     query($nome: String, $possuiModalidade: Boolean, $pageableDto: PageableDTOInput, $ativo: Boolean, $possuiTussVinculado: Boolean) {
      findAllProcedimentos(nome: $nome, possuiModalidade: $possuiModalidade, pageableDTO: $pageableDto, ativo: $ativo, possuiTussVinculado: $possuiTussVinculado) {
        content {
          nome
          id
          tuss22ProcedimentoEventoSaude {
            codigoTermo
          }
          modalidadeExames {
            codigo
            descricao
          }
        }
        last
      }
    }
  `,
    variables: variables,
  });

export const findAllProcedimentosPacsweByAgendamentoId = async (variables) => {
  const response = await Api.post("", {
    query: `
    query ($agendamentoId: Long) {
    findProcedimentosPacswebByAgendamentoId(agendamentoId: $agendamentoId) {
      nome
      id
      tuss22ProcedimentoEventoSaude {
        codigoTermo
      }
      modalidadeExames {
        codigo
        descricao
      }
    }
  }
  `, variables
  })

  if (response?.data?.errors) {
    throw new Error(response?.data?.errors[0]?.message)
  }

  return response?.data?.data?.findProcedimentosPacswebByAgendamentoId
}

export const findAllProcedimentosAtendimento = async (variables = {}) => {
  const searchDTODefault = {
    pageableDTO:{
      pageSize: 999,
      sortDir: "ASC",
      sortField: "nome",
    },
    nome: '',
    ativo: true
  }

  const response = await Api.post("", {
  query: `
  query ($ativo: Boolean, $pageableDTO: PageableDTOInput, $nome: String, $profissionalSaudeId: Long, $convenioId: Long) {
    findAllProcedimentos(ativo: $ativo, pageableDTO: $pageableDTO, nome: $nome, profissionalSaudeId: $profissionalSaudeId, convenioId: $convenioId) {
      last
      content {
        id
        nome
        ativo
        duracaoProcedimento
        convenioProcedimentos {
          convenio {
            id
          }
          valor
        }
      }
    }
  }
`,
  variables: {
    ...searchDTODefault,
    ...variables
  }
});

  return response.data.data.findAllProcedimentos
};

export const findAllProcedimentosRelatorio = async (nome) => {
  const pageableDTO = {
    sortDir: "ASC",
    sortField: "nome",
    pageSize: 999,
    pageNumber: 0
  }  

  const response = await Api.post("", {
    query: `
    query ($nome: String, $ativo: Boolean, $pageableDTO: PageableDTOInput) {
      findAllProcedimentos(nome: $nome, ativo: $ativo, pageableDTO: $pageableDTO) {
        content {
          id
          nome
        }
      }
    }
  `,
    variables: {
      nome: nome || "",
      ativo: true,
      pageableDTO
    }
  });

  return response.data.data.findAllProcedimentos.content;
};

export const procedimentoNomeJaExistente = async search => {
  const response =  await Api.post("", {
  query: `
    {
      procedimentoNomeJaExistente(search: "${search}")
    }`
  })
  
  return response.data.data.procedimentoNomeJaExistente;
};

export const findAllProcedimentosNormaisEOdontologicos = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($convenioId: Long, $ativo: Boolean, $pageableDTO: PageableDTOInput, $nome: String, $tiposProcedimentos: [TipoProcedimento], $localOdontograma: LocalOdontogramaInput) {
        findAllProcedimentos(convenioId: $convenioId, ativo: $ativo, pageableDTO: $pageableDTO, nome: $nome, tiposProcedimentos: $tiposProcedimentos, localOdontograma: $localOdontograma) {
          last
          content {
            id
            nome
            convenioProcedimentos {
              valor
              convenio {
                id
              }
            }
          }
        }
      }
    `,
    variables,
  })

  if (response.data.errors) throw Error(response.data.errors[0].message);

  return response.data.data.findAllProcedimentos;
}

export const findAllProcedimentoOdontologico = async (variables) => {
  const response = await Api.post("", {
    query: `query ($pageableDto: PageableDTOInput, $sujeitoAtencaoId: UUID, $dataLancamentoInicial: LocalDateTime, $dataLancamentoFinal: LocalDateTime, $status: [ProcedimentoOdontologicoStatus], $agendado: Boolean, $faturado: Boolean) {
      findAllProcedimentoOdontologico(pageableDTO: $pageableDto, sujeitoAtencaoId: $sujeitoAtencaoId, dataLancamentoInicial: $dataLancamentoInicial, dataLancamentoFinal: $dataLancamentoFinal, status: $status, agendado: $agendado, faturado: $faturado) {
        id
        descricao
        procedimento {
          id
          nome
        }
      }
    }`, variables
  })
 
  if (response.data.errors) throw Error(response.data.errors[0].message);
 
  return response.data.data.findAllProcedimentoOdontologico;
 }
 

export const findAllProfissionaisControleSessaoNaoFaturados = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($controleSessaoId:UUID) {
        findAllProfissionaisControleSessaoNaoFaturados
        (controleSessaoId:$controleSessaoId) {
         nome,
         id
        }
      }
    `,
    variables,
  })

  if (response.data.errors) throw Error(response.data.errors[0].message);

  return response.data.data.findAllProfissionaisControleSessaoNaoFaturados;
}

export const getNomeProcedimentos = async(variables) => {
  const response = await Api.post("", {
    query: `
      query ($nome: String, $ativo: Boolean, $pageableDTO: PageableDTOInput) {
        findAllProcedimentos(nome: $nome, ativo: $ativo, pageableDTO: $pageableDTO) {
          last
          content {
            id
            nome
          }
        }
      }
    `,
    variables
  });

  if (response.data.errors) throw Error(response.data.errors[0].message);

  return response.data.data.findAllProcedimentos;
};

export const procedimentosCsv = async (variables) => {
  const response = await Api.post("", {
    query: ` query procedimentosCsv($search: String, $pageableDto: PageableDTOInput, $ativo: Boolean) {
  procedimentosCsv(search: $search, pageableDto: $pageableDto, ativo: $ativo)
      }`,
    variables,
  });
  if (response.data.errors) throw Error(response.data.errors[0].message);

  return response.data.data.procedimentosCsv;
};

export const inativarProcedimentos = async (variables) => {
  const response = await Api.post("", {
    query: `
     mutation InativarProcedimentos($procedimentos: [ProcedimentoInput]) {
      inativarProcedimentos(procedimentos: $procedimentos) {
        nome
        id
        ativo
      }
    }
    `,
    variables,
  });

  if (response.data.errors) throw Error(response.data.errors[0].message);

  return response.data.data.inativarProcedimentos;
};

export const inativarTodosProcedimentos = async () => {
  const response = await Api.post("", {
    query: `
      mutation {
        inativarTodosProcedimentos
      }
    `,
  });

  if (response.data.errors) {
    throw Error(response.data.errors[0].message)
  };
};

export const findAllLigacaoProcedimento = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($tipoLigacaoEntidadesValores: TipoLigacaoEntidadesValores, $search: String, $entidadeId: String, $pageableDto: PageableDTOInput) {
        findAllLigacaoProcedimento(tipoLigacaoEntidadesValores: $tipoLigacaoEntidadesValores, search: $search, entidadeId: $entidadeId, pageableDTO: $pageableDto) {
          last
          content {
            descricao
            id
            valor
            quantidade
          }
        }
      }`,
    variables: variables,
  });

  if(response.data.erros){
    throw response.data.errors[0]
  }else{
    return response.data.data.findAllLigacaoProcedimento
  }
};

export const findValoresByConvenioAndProcedimentos = async(variables) => {
  const response = await Api.post('', {
    query: `
      query ($convenioId: Long, $procedimentoIds: [UUID]) {
        findValoresByConvenioAndProcedimentos(convenioId: $convenioId, procedimentoIds: $procedimentoIds) {
          procedimento {
            nome
          }
          valor
        }
      }
    `,
    variables,
  });

  if (response.data.errors) throw Error(response.data.errors[0].message);

  return response.data.data.findValoresByConvenioAndProcedimentos;
}
